import { createFileRoute } from "@tanstack/react-router"
import ProductSplitsTable from "~/components/demand-plan/ProductSplitsTable"
import { WorkspacePage } from "~/components/design-system/pages"
import ViewConfiguration from "~/components/planning/ViewConfiguration"
import { COLLECTIONS_VARIANTS_SPLITS_TABLE_ID } from "~/constants"
import { useCollectionContext } from "~/context/CollectionProvider"
import { useVariants } from "~/hooks/useVariants"
import { useMemo } from "react"
import { usePageTracking } from "~/hooks/usePageTracking"

export const Route = createFileRoute("/_auth/demand-planning/fashion/$collectionId/_layout/splits")(
  {
    component: RouteComponent,
  },
)

function RouteComponent() {
  usePageTracking("Collection - Splits")
  const { collections } = useCollectionContext()
  const rawVariants = useVariants()
  const variants = useMemo(() => {
    return rawVariants.filter((v) => collections.some((c) => c.variantIds.includes(v.variantId)))
  }, [rawVariants, collections])

  return (
    <WorkspacePage
      fillContent
      contentClassName="h-full"
      viewConfiguration={
        <ViewConfiguration
          tableId={COLLECTIONS_VARIANTS_SPLITS_TABLE_ID}
          showFilters
          showChannelSelect
        />
      }
    >
      <ProductSplitsTable collectionIds={collections.map((c) => c.id)} variants={variants} />
    </WorkspacePage>
  )
}
